import React, { useState } from "react";

import { formatTimer, useInterval } from "../services";
import { TextLabel, Icon, Row } from "../lib";

type Props = {
  value: number;
};

export function Timer({ value }: Props) {
  const [count, setCount] = useState(value);

  useInterval(() => {
    if (count > 0) setCount(count - 1);
  }, 1000);

  return (
    <Row.L>
      <Icon name="timer" em small />
      <TextLabel ml="1" em>
        {formatTimer(count)}
      </TextLabel>
    </Row.L>
  );
}
